// Modules
// =============================================================================

import $ from 'zepto';
import Map from 'components/map';


// Class
// =============================================================================

export default class AdhView {
  constructor() {
    // Start
    this._preloadImages();
    this._initNavigation();
    this._initHero();
    this._initMap();
    this._toggle();
  }


  /**
   * this._preloadImages()
   * Dynamic image load
   * @private
   */
  _preloadImages() {
    let images = $('[data-image]');
    let counter = images.length;
    let flag = 0;

    // Run
    /*$.each(images, (i, el) => {
      let $el = $(el);
      let imageUrl = $el.attr("data-image");

      loadImage(imageUrl, function(){
        console.log('LOAD', counter, flag);
        $el.css('background-image', 'url('+imageUrl+')');
      });

    });*/

    loadNext();

    function loadNext(){
      let image = $(images[flag]);
      let url = image.attr("data-image");

      loadImage(url, function(){
        image.css('background-image','url('+url+')');
      });
    }

    function loadImage(url, callback){
      var img = new Image();

      img.onload = function() {
          flag++;

          callback();

          if(flag != counter){
            loadNext();
          }
      };

      img.src = url;

    } 

    
  }


  /**
   * this._initNavigation()
   * Create navigation with data-href attribute
   * @private
   */
  _initNavigation() {
    let links = $('[data-href]');

    $.each(links, (i, el) => {
      let $el = $(el);

      // Redirect
      $el.on('click', () => {
        let href = $el.data('href');
        let target = $el.attr('target');

        if (href) {
          if (href.length > 1 && href.charAt(0) !== '#') {
            if (target && target === '_blank')
              window.open(href);
            else
              window.location.href = href;
          }
        }
      });

      // Disable inheritance
      $.each($el.find('a, button'), (i, child) => {
        let $child = $(child);

        $child.on('click', (event) => {
          event.stopPropagation();
        });
      });
    });
  }


  /**
   * this._initHero()
   * Create hero slider
   * @private
   */
  _initHero() {
    let hero = $('.js-hero');
    let items = hero.find('.hero__item');
    let index = 0;

    // Show first item
    items.eq(index).addClass('is-visible');

    // Run
    let run = setInterval(() => {
      index++;

      // Check index limitation
      if (index >= items.length) {
        index = 0;
      }

      // Clean up
      items.filter('.is-hidden')
           .removeClass('is-hidden');

      // Hide old one
      items.filter('.is-visible')
           .removeClass('is-visible')
           .addClass('is-hidden');

      // Show new one
      setTimeout(() => {
        items.eq(index).addClass('is-visible');
      }, 100);
    }, 7000);
  }


  /**
   * this._initMap()
   * Initialize maps
   */
  _initMap() {
    const $map = $('.map__canvas');
    const $markers = $('*[data-coords]');

    if ($map.length !== 0) {
      this.Map = new Map($map);

      $.each($markers, (i, el) => {
        const $el = $(el);
        const coords = $el.data('coords');

        // Add marker
        this.Map.marker({
          id: i,
          position: coords
        });
      });
    }
  }


  /**
   * this._toggle()
   * Toggle elements
   */
  _toggle() {
    const $elements = $('[data-toggle]');

    $.each($elements, (i, el) => {
      const $el = $(el);

      $el.on('click', (event) => {
        let selector = $el.data('toggle').selector;
        let classname = $el.data('toggle').classname;
        let $target = $(selector);

        if (!classname) {
          classname = 'is-visible';
        }

        if ($target.hasClass(`${classname}`))
          $target.removeClass(`${classname}`);
        else
          $target.addClass(`${classname}`);
      });
    });
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/views/adh-view.js
 **/